import { gql } from '@apollo/client';

export const CREATE_CUSTOM_INTERVIEW_NOW_NOTIFICATION = gql`
  mutation CreateCustomInterviewNowNotification(
    $input: CreateCustomInterviewNowNotificationInput!
  ) {
    createCustomInterviewNowNotification(input: $input) {
      questionCount
      athleteCount
    }
  }
`;
